<script lang="ts">
  import Button from '$shared/atoms/Button/Button.svelte';
  import { ButtonStyle } from '$shared/constants/ButtonStyle';
  import Icon from '$shared/atoms/Icon/Icon.svelte';

  interface Props {
    actionLabel?: string;
    actionIcon?: string;
    loading?: boolean;
    onbanneraction?: (payload: { actionLabel: string }) => void;
  }

  let { actionLabel = '', actionIcon = '', loading = false, onbanneraction }: Props = $props();

  const onClickAction = (): void => {
    onbanneraction?.({ actionLabel: actionLabel });
  };
</script>

{#if actionLabel}
  <Button {loading} style={ButtonStyle.Link} name="merge-action-btn" onclick={onClickAction}>
    <div class="label">
      <div class="action-text">{actionLabel}</div>
      {#if actionIcon}
        <div class="icon">
          <Icon value={actionIcon} fontSize="18px" size="18px" />
        </div>
      {/if}
    </div>
  </Button>
{/if}

<style>
  .label {
    display: inline-flex;
    align-items: center;
  }
  .label .icon {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
  }
</style>
